<template>
  <div>
    <b-modal
      title="DETALHES DO SERVIÇO"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-service :service="service" />
    </b-modal>
    <Filters @paginate="handleFilters" :loading="loading" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small class="mr-2">PAGO</small>
          <v-icon color="success" small>mdi-check-circle-outline</v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.paid_in_date`]="{ item }">
          {{ formatDate(item.paid_in_date, false) }}
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ moment(item.date).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:[`item.service_charge_type`]="{ item }">
          {{ item.service_charge_type_name }}
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          {{ item.quantity }}
        </template>
        <template v-slot:[`item.service`]="{ item }">
          {{ item.service_description }}
        </template>
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDate(item.due_date, false) }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ formatPrice(item.value) }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn x-small class="btn-primary m-1" @click="handleDetails(item)">
            <i class="fas fa-eye mr-2"></i>DETALHES
          </v-btn>
        </template>
      </v-data-table>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import Filters from "../../Components/Filters.vue";

import DetailsService from "./service/details.vue";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate, formatPrice } from "../../../lib/format";

import moment from "moment";

export default {
  name: "PaidOut",

  components: {
    ErrorsMessages,
    Filters,
    DetailsService,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      status: 3,
      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "DT/PAGAMENTO", value: "paid_in_date", sortable: false },
        { text: "DATA DO SERVIÇO", value: "date", sortable: false },
        { text: "SERVIÇO", value: "service", sortable: false },
        {
          text: "TIPO DE COBRANÇA",
          value: "service_charge_type",
          sortable: false,
        },
        { text: "QUANTIDADE", value: "quantity", sortable: false },
        { text: "VENCIMENTO", value: "due_date", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "AÇÕES", value: "details", sortable: false },
      ],

      data: [],

      service: {},

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatDate,
    formatPrice,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
    },

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleDetails(service) {
      this.service = service;
      this.$bvModal.show("details");
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          page,
          itemsPerPage,
          status,
          month,
          dayMonthYear,
        };

        const response = await api.get(
          "/rest-home/resident/financial-services",
          {
            params,
          }
        );

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
